//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from '../../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    expansionItems: {
      type: Array,
      default () {
        return []
      }
    },
    objectType: {
      type: String,
      default: ''
    }
  },
  methods: {
    getClassRow: function (name, row) {
      let classRow = ''
      if (name == 'value' && row.synchronical !== undefined && !['tl', 't7'].includes(this.objectType)) {
        classRow = row.synchronical ? '' : 'bg-red-2 '
      } else if (name == 'name') {
        classRow = 'text-bold'
      } else if (name == 'object' && row.synchronical !== undefined && ['tl', 't7'].includes(this.objectType)) {
        classRow = row.synchronical ? '' : 'text-negative'
      }
      return classRow
    }
  }
}
